import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from './Loader.style';
import { colors } from '../../themes/default';

const Loader = ({ size, className, progress, thickness, color }) => (
  <CircularProgress
    size={size}
    color={color}
    thickness={thickness}
    className={className}
    value={progress != null ? progress : undefined}
    variant={progress != null ? 'determinate' : undefined}
  />
);

Loader.defaultProps = {
  size: 25,
  color: colors.designSystem.purple70,
  thickness: undefined,
  progress: undefined,
  className: '',
};

Loader.propTypes = {
  size: PropTypes.number,
  progress: PropTypes.number,
  color: PropTypes.string,
  thickness: PropTypes.number,
  className: PropTypes.string,
};

export default Loader;
